import { render, staticRenderFns } from "./AppHeaderAddressbook.vue?vue&type=template&id=58b7ff1c"
import script from "./AppHeaderAddressbook.vue?vue&type=script&lang=js"
export * from "./AppHeaderAddressbook.vue?vue&type=script&lang=js"
import style0 from "./AppHeaderAddressbook.vue?vue&type=style&index=0&id=58b7ff1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports